import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { em } from 'polished';
import NameHeading from '../NameHeading';
import { appTheme } from '../../../theme';

const Wrapper = styled.div`
  margin-bottom: 1em;
  max-width: ${em(appTheme.sizing.formMaxWidth)};
`;

function DetailsLayout({ children, heading }) {
  return (
    <Wrapper>
      <NameHeading>{heading}</NameHeading>
      {children}
    </Wrapper>
  );
}

DetailsLayout.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
};

export default DetailsLayout;



// WEBPACK FOOTER //
// ./src/modules/common/layouts/DetailsLayout.js